export default {
  en: 'EN-en',
  tr: 'TR-tr',
  de: 'DE-de',
  es: 'ES-es',
  fr: 'FR-fr',
  pl: 'PL-pl',
  pt: 'PT-pt',
  ru: 'RU-ru',
  da: 'Da-da',
  ar: 'AR-ar',
  no: 'NO-no',
  nb: 'NB-no',
  nn: 'NN-no',
  it: 'IT-it',
  ro: 'RO-ro'
};
